import { Grid, Paper, styled } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { useEffect } from 'react';
import Store from 'src/stores/RootStore';
import UserStore from 'src/stores/UserStore';
import DashboardSlideShow from './DashboardSlideShow';

const Root = styled('div')(({ theme }) => ({
    margin: `-${theme.spacing(3)}`,
    flexGrow: 1,
    display: 'flex',
}));

interface DashboardProps {
    store?: typeof Store.Type;
    user?: typeof UserStore.Type;
}

const DashboardSimple = inject(
    'store',
    'user',
)(
    observer(({ store, user }: DashboardProps) => {
        const lang = user!.preferredLang;
        useEffect(() => {
            store!.marketing.setActiveMarketingTool('DASHBOARD');
            store!.marketing.getMarketingBanners(lang);
        }, [store, lang]);

        return (
            <Root>
                <Grid container data-testid="dashboard">
                    <Grid display="flex" item xs={12}>
                        <Paper
                            elevation={0}
                            style={{ display: 'flex', flex: 1, borderRadius: 0, position: 'relative' }}
                        >
                            <DashboardSlideShow isSimple />
                        </Paper>
                    </Grid>
                </Grid>
            </Root>
        );
    }),
);

export default DashboardSimple;
